import { useState, useEffect } from 'react';
import type { PropsWithChildren, FC } from 'react';

import { TeamingCallEventBus } from 'features/teaming/teaming-base/services';
import { styledProps } from 'features/theme/styled';
import { useWhileComponentMounted } from 'features/utils/hook';

interface AutoHideContentProps extends PropsWithChildren {
  delay?: number;
}

export const AutoHideContent: FC<AutoHideContentProps> = ({
  delay = 5000,
  children,
}) => {
  const whileComponentMounted = useWhileComponentMounted();
  const [isShowModal, setIsShowModal] = useState(true);

  const showPopupFor = (ms: number) => {
    setIsShowModal(true);

    setTimeout(() => {
      setIsShowModal(false);
    }, ms);
  };

  useEffect(() => {
    showPopupFor(delay);

    TeamingCallEventBus.$showContent
      .pipe(whileComponentMounted())
      .subscribe(() => {
        showPopupFor(delay);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <StyledContainer $isShowModal={isShowModal}>{children}</StyledContainer>
  );
};

const StyledContainer = styledProps('div')<{
  $isShowModal: boolean;
}>`
  ${({ $isShowModal }) =>
    !$isShowModal &&
    `
  visibility: hidden;
  opacity: 0;
  transition: visibility 0s 2s, opacity 2s linear;
  `}
`;
